import {
  ApiGetRequest,
  ApiPostRequest,
  ApiDeleteRequest,
  ApiPutRequest,
} from '../../api';
import moment from 'moment-mini';
import { showNotif } from '../notification';

export const state = {
  data: {
    title: 'Document Interchange',
    breadcrumb: [
      {
        text: 'Dashboard',
        href: '/opr',
      },
      {
        text: 'Document Interchange',
        href: '/opc/doc/interchange',
        active: true,
      },
    ],
    showmodal: false,
    items: [],
    total: 0,
    page: 1,
    limit: 10,
    pageOptions: [10, 25, 50, 100],
    search: '',
    sortBy: 'id_interchange',
    sortDesc: true,
    doc_type_filter: '',
    status_filter: '1',
    date_filter: [],
    fields: [
      {
        key: 'code_interchange',
        label: 'Kode',
        sortable: true,
      },
      {
        key: 'principle',
        label: 'Principle',
        sortable: true,
      },
      {
        key: 'doc_no',
        label: 'B/L No',
        sortable: true,
      },
      {
        key: 'created_at',
        label: 'Date',
        sortable: true,
      },
      {
        key: 'expired_date',
        label: 'Expired',
        sortable: true,
      },
      {
        key: 'consignee',
        label: 'Consignee',
      },
      {
        key: 'doc_type',
        label: 'Type',
        sortable: true,
      },
      {
        key: 'ex_vessel',
        label: 'Exvessel',
        sortable: true,
      },
      {
        key: 'voy',
        label: 'Voy',
        sortable: true,
      },
      {
        key: 'aksi',
      },
    ],
    detail: false,
    form: {
      code_principle: '',
      doc_no: '',
      doc_type: '',
      expired_date: '',
      consignee: '',
      consignee_group: '',
      ex_vessel: '',
      voy: '',
      harbor: '',
      out_harbor: '',
      ex_commodity: '',
      port_of_discharge: '',
      place_of_ic: '',
      trucking: '',
      cont_from: '',
      is_trucking_dkm: 0,
      containers: [],
      items_consignee_group: [],
    },
    cont_type: [],
    cont_cleaning: [],
    form_checking: {
      container: '',
      size: '',
      type: '',
      nopol: '',
      driver: '',
      expired_date: '',
      harbor: '',
      out_harbor: '',
    },
  },
};

export const getters = {
  form(state) {
    return state.data.form;
  },
  form_checking(state) {
    return state.data.form_checking;
  },
};

export const mutations = {
  changeInterchange(state, data) {
    state.data = Object.assign({}, state.data, data);
  },
};

export const actions = {
  async getListInterchange({ commit, state }) {
    commit('changeInterchange', {
      loading: true,
    });

    const { data } = state;
    let params = {
      q: data.search,
      limit: data.limit,
      page: data.page,
      sort: data.sortBy,
      order: data.sortDesc ? 'desc' : 'asc',
    };

    if (data.date_filter && data.date_filter.length > 0) {
      params.start_date = data.date_filter[0]
        ? moment(data.date_filter[0]).format('YYYY-MM-DD')
        : '';
      params.end_date = data.date_filter[1]
        ? moment(data.date_filter[1]).format('YYYY-MM-DD')
        : '';
    }

    if (data.doc_type_filter && data.doc_type_filter !== '') {
      params.doc_type = data.doc_type_filter;
    }

    if (data.status_filter && data.status_filter !== '') {
      params.status = data.status_filter;
    }

    let result = await ApiGetRequest(`opr/interchange`, params);
    commit('changeInterchange', {
      items: !result.error ? result.data.object : [],
      total: !result.error ? result.data.total : 0,
      loading: false,
    });

    return !result.error ? true : false;
  },

  async checkDocNumber({ commit, state, dispatch }) {
    commit('changeInterchange', {
      loading: true,
    });

    const { data } = state;
    let result = await ApiGetRequest(`opr/interchange/check-doc-number`, {
      doc_no: data.form.doc_no ? data.form.doc_no : '',
    });

    if (result.data.object) {
      commit('changeInterchange', {
        loading: false,
        form: {
          ...data.form,
          doc_no: '',
        },
      });

      showNotif(dispatch, {
        message: 'B/L No sudah terdaftar dalam sistem sebelumnya',
        type: 'error',
      });
    } else {
      commit('changeInterchange', {
        loading: false,
      });
    }

    return result.error ? false : true;
  },

  async getConsigneeGroup({ commit, state, dispatch }) {
    commit('changeInterchange', {
      loading: true,
    });
    const { data } = state;
    let result = await ApiGetRequest(
      `opr/principles/${data.form.id_principle}/consignee-group?doc_type=${
        data.form && data.form.doc_type ? data.form.doc_type : ''
      }`
    );

    commit('changeInterchange', {
      loading: false,
      form: {
        ...data.form,
        items_consignee_group: result.error ? [] : result.data.object,
      },
    });

    if (result.data.object && result.data.object.length === 0) {
      showNotif(dispatch, {
        message: 'Belum ada harga untuk principle ini',
        type: 'error',
      });
    }

    return result.error ? false : true;
  },

  async getDetailInterchange({ commit, state }, payload = null) {
    commit('changeInterchange', {
      loading: true,
    });

    const { data } = state;
    let result = await ApiGetRequest(`opr/interchange/${payload.id}`);
    let dataForm = Object.assign(
      {},
      data.form,
      result.error ? {} : result.data.object
    );

    dataForm.expired_date = dataForm.expired_date
      ? moment(dataForm.expired_date).format('DD/MM/YYYY')
      : '';

    dataForm.out_harbor = dataForm.out_harbor
      ? moment(dataForm.out_harbor).format('DD/MM/YYYY')
      : '';

    commit('changeInterchange', {
      loading: false,
      detail: result.error ? false : result.data.object,
      form: dataForm,
    });

    return result.error ? false : true;
  },

  async createInterchange({ commit, state, dispatch }) {
    commit('changeInterchange', {
      loading: true,
    });

    let form = state.data.form;
    let result = await ApiPostRequest(`opr/interchange`, form);
    commit('changeInterchange', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
        type: 'success',
      });
    }

    return result.error ? false : true;
  },

  async updateInterchange({ commit, state, dispatch }, payload = null) {
    commit('changeInterchange', {
      loading: true,
    });

    let form = state.data.form;
    let result = await ApiPutRequest(`opr/interchange/${payload.id}`, form);
    commit('changeInterchange', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
        type: 'success',
      });
    }

    return result.error ? false : true;
  },

  async deleteInterchange({ commit, dispatch }, payload = null) {
    commit('changeInterchange', {
      loading: true,
    });

    let result = await ApiDeleteRequest(`opr/interchange/${payload.id}`);
    commit('changeInterchange', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
        type: 'success',
      });
    }

    return result.error ? false : true;
  },

  async undoDeleteInterchange({ commit, dispatch }, payload = null) {
    commit('changeInterchange', {
      loading: true,
    });

    let result = await ApiPostRequest(
      `opr/interchange/undo-destroy/${payload.id}`
    );
    commit('changeInterchange', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
        type: 'success',
      });
    }

    return result.error ? false : true;
  },

  async searchContainer({ commit, state, dispatch }) {
    commit('changeInterchange', {
      loading: true,
    });

    const { data } = state;
    let result = await ApiGetRequest(
      `opr/interchange/checking?search=${data.search_cont || ''}`
    );

    if (!result.error && result.data.object) {
      commit('changeInterchange', {
        form_checking: {
          ...result.data.object,
          out_harbor: result.data.object.out_harbor
            ? moment(result.data.object.out_harbor).format('DD/MM/YYYY')
            : '',
          expired_date: result.data.object.expired_date
            ? moment(result.data.object.expired_date).format('DD/MM/YYYY')
            : '',
        },
      });
    } else {
      showNotif(dispatch, {
        message: 'Container tidak ditemukan',
        type: 'error',
      });

      commit('changeInterchange', {
        search_cont: '',
        form_checking: {
          container: '',
          size: '',
          type: '',
          nopol: '',
          driver: '',
          expired_date: '',
          harbor: '',
          out_harbor: '',
        },
      });
    }

    commit('changeInterchange', {
      loading: false,
    });

    return result.error ? false : true;
  },

  async createChecking({ commit, state, dispatch }) {
    commit('changeInterchange', {
      loading: true,
    });

    const { data } = state;
    let result = await ApiPostRequest(
      `opr/interchange/checking`,
      data.form_checking
    );
    commit('changeInterchange', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
        type: 'success',
      });
    }

    return result.error ? false : true;
  },
};
